<div class="rec-container ">
  <h3>{{latestRecording}}</h3>
  <h2>Search Land Records by  <img id="img" src="images/info.jpg" height="18" width="18" /></h2>
  <dx-tooltip target="#img"
              showEvent="dxhoverstart"
              hideEvent="dxhoverend"
              >
    <div *dxTemplate="let data of 'content'">
      <span >
        <b>Search Tips</b><br />
        <p>As of January 1, 2022 companies with numeric names are indexed with the actual number.<br />  Prior to this, you have to spell out the number.
        <br /><br />NOTE: An asterisk "*" may be used as a wildcard</p>
      </span>
    </div>
  </dx-tooltip>
  
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">

    <div class="name-role-container">
      <div class="name-container">
        <app-compound-name></app-compound-name>
      </div>
      <div class="role-container">
        <div class="space"></div>
        <app-role></app-role>
      </div>
      <!--<div class="contains-container">
        <div class="space"></div>
        <app-contains></app-contains>
      </div>-->
    </div>
    <!--<div class="space"></div>
    <div><h3 style="font-weight:bold">Second Name Search (Optional) Shows only Documents that include both Names</h3></div>
    <div class="space"></div>
    <div class="name-role-container mb-55">
      <div class="name-container">
        <app-compound-name2></app-compound-name2>
      </div>
      <div class="role-container">
        <div class="space"></div>
        <app-role2></app-role2>
      </div>
    </div>-->

    <div class="date-container">

      <lib-date-range-parent></lib-date-range-parent>
    </div>
    <div class="city-container">
      <app-city-town-ex></app-city-town-ex>
    </div>
    <div class="doc-container">
      <app-doctypeex></app-doctypeex>
    </div>
    <div style="text-align: center">
      <button class="btn btn-default" type="submit">
        SEARCH
      </button>

    </div>

    <!--<button class="btn btn-default" type="button" (click)="search('/rec-name-result-pg')">
      SEARCH
    </button>-->
  </form>
  <!--  <button class="btn btn-default" type="button" (click)="search('/rec-alpha-result-pg')">Alpha List</button> -->

  <hr />
  <div><h3 style="font-weight:bold">Name Variation Search (a contains search)</h3></div>
  <div>
    <label>
      Over the years, names were indexed differently.  To view all variations,
      this search shows any occurrence of the last name, in the order entered in the search field, wherever located in the database.
      and first name as entered where it exists in the index.  Scroll down the list to see variations.  When in doubt of how a name was indexed,
      it is recommended that you use the name variation search.
    </label>
  </div>
  <div class="name-role-container mb-55">
    <div class="name-container">
      <app-compound-name2></app-compound-name2>
    </div>
    <div class="role-container">
      <div class="space"></div>
      <app-role2></app-role2>
    </div>
  </div>
  <div class="text-align" align="center">
    <button class="btn btn-default" type="button" (click)="search('/rec-alpha-result-pg')">Name List</button>
  </div>
</div>
